export const statusConstants = {
  SUCCESS: 'STATUS_SUCCESS',
  ERROR: 'STATUS_ERROR',
  CLEAR: 'STATUS_CLEAR'
};